// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__6KY-H","logo":"Loading_logo__tD-Za","loadingDescription":"Loading_loadingDescription__rODip"};